(function () {
  'use strict';
  if (window.__ImwsFormDefined) return;
  window.__ImwsFormDefined = true;

  /* ── Static data ──────────────────────────────────────────── */
  var DETECTED_CONTAMINANTS = [
    'Aluminum','Selenium','cis-1,2-Dichloroethylene','Monochloroacetic acid',
    'Monobromoacetic acid','1,1-Dichloroethylene','Toluene, tert-Butyl alcohol'
  ];
  var NOT_DETECTED = [
    ['1,1,1,2-Tetrachloroethane','1,1,1-Trichloroethane','1,1,2,2-Tetrachloroethane','1,1,2-Trichloroethane','1,1-Dichloroethane','1,1-Dichloropropene','1,2,3-Trichlorobenzene','1,2,3-Trichloropropane','1,2,4-Trichlorobenzene','1,2,4-Trimethylbenzene','1,2-Dibromo-3-chloropropane (DBCP)','1,2-Dichloroethane','1,2-Dichloropropane','1,3,5-Trimethylbenzene','1,3-Butadiene','1,3-Dichloropropane','1,3-Dichloropropene','17-beta-Estradiol','2,2-Dichloropropane','2,4,5-T, 2,4,5-TP (Silvex)','2,4-D, 2,4-DB, 2,4-Dinitrotoluene','2,6-Dinitrotoluene','2-Chloroethylvinyl ether','3-Hydroxycarbofuran','4,4\'-dde','4-Androstene-3,17-dione','Acetochlor, Acifluorfen (Blazer)','Alachlor (Lasso)','Aldicarb','Aldicarb sulfone','Aldicarb sulfoxide'],
    ['Aldrin','alpha-Lindane','Antimony','Atrazine','Baygon (Propoxur)','Bentazon (Basagran)','Benzene','Benzo[a]pyrene','Beryllium','beta-BHC','Bromacil','Bromobenzene','Bromochloromethane','Bromomethane','Butachlor','Cadmium','Caffeine','Captan','Carbaryl','Carbofuran','Carbon tetrachloride','Carbophenothion','Chlordane','Chloroethane','Chloromethane','Chlorothalonil (Bravo)','Chlorpropham','cis-1,3-Dichloropropene','Cobalt','Cyanazine (Bladex)','Cyanide'],
    ['Dalapon','DCPA mono- and di-acid degradates','delta-BHC','Di(2-ethylhexyl) adipate','Di(2-ethylhexyl) phthalate','Diazinon (Spectracide)','Dibromomethane','Dicamba','Dichlorodifluoromethane','Dichloromethane (methylene chloride)','Dichlorprop','Dieldrin','Dimethoate','Dinoseb','Diphenamide','Diquat','Disulfoton','Endosulfan I','Endosulfan II','Endosulfan sulfate','Endothall','Endrin','Endrin aldehyde','EPTC (Eptam)','Equilin','Estriol','Estrone','Ethinyl estradiol','Ethyl tert-butyl ether','Ethylbenzene']
  ];

  /* ── Helpers ──────────────────────────────────────────────── */
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function toTitleCase(s) {
    return s.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function filterOverLimit(list) {
    return list.filter(function (c) {
      var v = Number(c.ContaminantValue);
      var hg = Number(c.ContaminantHGValue);
      if (!v || !hg || hg <= 0) return false;
      return Math.floor(v / hg) > 0;
    }).sort(function (a, b) {
      return Math.floor(Number(b.ContaminantValue) / Number(b.ContaminantHGValue))
           - Math.floor(Number(a.ContaminantValue) / Number(a.ContaminantHGValue));
    });
  }

  function attr(el, key, fallback) {
    return el.getAttribute('data-' + key) || fallback || '';
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function toPpb(raw) {
    if (!raw || raw === -1 || isNaN(raw)) return null;
    return Number((raw * 1000).toFixed(3));
  }

  function buildProcessedContaminants(contaminants) {
    var result = [];
    for (var i = 0; i < contaminants.length; i++) {
      var c = contaminants[i];
      var utilityRaw = Number(c.ContaminantValue);
      var guidelineRaw = Number(c.ContaminantHGValue);
      if (!utilityRaw || !guidelineRaw || utilityRaw === -1 || guidelineRaw === -1 || isNaN(utilityRaw) || isNaN(guidelineRaw)) continue;
      var ratio = Math.floor(utilityRaw / guidelineRaw);
      if (ratio <= 0) continue;
      var utility = toPpb(utilityRaw);
      var guideline = toPpb(guidelineRaw);
      var legal = toPpb(Number(c.ContaminantMCLValue));
      var stateAvg = toPpb(Number(c.ContaminantStateAvg));
      var nationalAvg = toPpb(Number(c.ContaminantNationalAvg));
      result.push({
        id: c.ContaminantCode || i,
        contaminant: [c],
        ratio: ratio,
        utility: utility,
        guideline: guideline,
        legal: legal,
        stateAvg: stateAvg,
        nationalAvg: nationalAvg,
        timeline: String(c.ContaminantTimeFrame || ''),
        maxBarValue: Math.max(utility || 0, guideline || 0, stateAvg || 0, nationalAvg || 0, legal || 0)
      });
    }
    return result;
  }

  /* ── Donut SVG ────────────────────────────────────────────── */
  function buildDonutSVG(count, size) {
    size = size || 285;
    var sw = 17.471;
    var r = (size - sw) / 2;
    var circ = 2 * Math.PI * r;
    var half = size / 2;
    var target = Math.min(Math.max(count, 0), 100);
    var extra = (target / 100) * 360;
    var totalAngle = 360 + extra;
    var lightAngle = Math.min(totalAngle, 360);
    var lightOff = circ * (1 - lightAngle / 360);
    var darkAngle = Math.max(totalAngle - 360, 0);
    var darkOff = circ * (1 - darkAngle / 360);

    var svg = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">'
      + '<defs>'
      + '<linearGradient id="imws-dg" x1="0" y1="0" x2="' + size + '" y2="' + size + '" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#6F7F84"/><stop offset="100%" stop-color="#9AA7AB"/></linearGradient>'
      + '<linearGradient id="imws-dl" x1="0" y1="0" x2="' + size + '" y2="' + size + '" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#f03e3f" stop-opacity="0.6"/><stop offset="50%" stop-color="#f03e3f" stop-opacity="0.4"/><stop offset="100%" stop-color="#fd1617" stop-opacity="0.6"/></linearGradient>'
      + '<linearGradient id="imws-dd" x1="0" y1="0" x2="' + size + '" y2="' + size + '" gradientUnits="userSpaceOnUse"><stop offset="0%" stop-color="#fd1617" stop-opacity="0.7"/><stop offset="50%" stop-color="#fd1617" stop-opacity="0.8"/><stop offset="100%" stop-color="#fd1717"/></linearGradient>'
      + '</defs>'
      + '<circle cx="' + half + '" cy="' + half + '" r="' + r + '" fill="none" stroke="url(#imws-dg)" stroke-width="' + sw + '"/>'
      + '<circle cx="' + half + '" cy="' + half + '" r="' + r + '" fill="none" stroke="url(#imws-dl)" stroke-width="' + sw + '" stroke-linecap="round" stroke-dasharray="' + circ + ' ' + circ + '" stroke-dashoffset="' + lightOff + '" transform="rotate(-90 ' + half + ' ' + half + ')"/>';
    if (darkAngle > 0) {
      svg += '<circle cx="' + half + '" cy="' + half + '" r="' + r + '" fill="none" stroke="url(#imws-dd)" stroke-width="' + sw + '" stroke-linecap="round" stroke-dasharray="' + circ + ' ' + circ + '" stroke-dashoffset="' + darkOff + '" transform="rotate(-90 ' + half + ' ' + half + ')"/>';
    }
    svg += '</svg>';
    return svg;
  }

  /* ── Contaminant card builder ─────────────────────────────── */
  function buildCard(c, idx, labels) {
    var uRaw = Number(c.ContaminantValue);
    var gRaw = Number(c.ContaminantHGValue);
    var lRaw = Number(c.ContaminantMCLValue);
    var sRaw = Number(c.ContaminantStateAvg);
    var nRaw = Number(c.ContaminantNationalAvg);
    var timeline = c.ContaminantTimeFrame ? String(c.ContaminantTimeFrame) : 'the reported period';

    var utility = (uRaw && uRaw !== -1) ? uRaw * 1000 : null;
    var guideline = (gRaw && gRaw !== -1) ? gRaw * 1000 : null;
    var legal = (lRaw && lRaw !== -1) ? lRaw * 1000 : null;
    var stateAvg = (sRaw && sRaw !== -1) ? sRaw * 1000 : null;
    var natAvg = (nRaw && nRaw !== -1) ? nRaw * 1000 : null;
    var ratio = (gRaw && uRaw) ? Math.floor(uRaw / gRaw) : 'NA';
    var maxBar = Math.max(utility || 0, guideline || 0, stateAvg || 0, natAvg || 0, legal || 0);

    function barW(v) { return (!v || maxBar === 0) ? 0 : (v / maxBar) * 100; }
    function barRow(label, value, suffix, bold, isLegal) {
      var lbl = bold ? 'imws-bar__label imws-bar__label--bold' : 'imws-bar__label';
      var fillCls = isLegal ? 'imws-bar__fill imws-bar__fill--legal' : 'imws-bar__fill';
      var valStr = (value !== null) ? value.toFixed(3) + ' ppb' : 'NA ppb';
      if (suffix && value !== null) valStr += ' ' + suffix;
      if (value === null && isLegal) valStr = 'None';
      return '<div><p class="' + lbl + '">' + esc(label) + '</p>'
        + '<div class="imws-bar__track"><div class="' + fillCls + '" style="width:' + barW(value) + '%"></div></div>'
        + '<p class="imws-bar__value">' + valStr + '</p></div>';
    }

    var id = c.ContaminantCode || idx;
    var html = '<div class="imws-contaminant-card" data-card-id="' + id + '">'
      + '<div class="imws-contaminant-card__header">'
      + '<p class="imws-contaminant-card__name">' + esc(c.ContaminantName || 'Unknown') + '</p>'
      + '<button type="button" class="imws-contaminant-card__toggle" data-toggle="' + id + '" aria-expanded="false" aria-controls="imws-contaminant-expanded-' + id + '" aria-label="Expand details for ' + esc(c.ContaminantName || 'Unknown') + '">+</button>'
      + '</div>'
      + '<p class="imws-contaminant-card__effect">Potential Effect: <strong>' + esc(c.ContaminantEffect || 'NA') + '</strong></p>'
      + '<div><p class="imws-contaminant-card__ratio">' + (typeof ratio === 'number' ? ratio + 'x' : 'NA') + '</p>'
      + '<p class="imws-contaminant-card__ratio-label">Above EWG health guidelines</p></div>'
      + '<div class="imws-contaminant-card__expanded" style="display:none" data-expanded="' + id + '" id="imws-contaminant-expanded-' + id + '" hidden>'
      + '<hr>';

    if (c.ContaminantDescription) {
      html += '<p class="imws-contaminant-card__desc">' + c.ContaminantDescription + '</p>';
    }
    html += '<p class="imws-contaminant-card__effect">Potential Effect: <strong>' + esc(c.ContaminantEffect || 'Unknown') + '</strong></p><hr>';
    html += '<div class="imws-contaminant-card__bars">'
      + barRow(labels.guideline, guideline, 'or less', false, false)
      + barRow(labels.national, natAvg, '', false, false)
      + barRow(labels.state, stateAvg, '', false, false)
      + barRow(labels.home, utility, '', true, false)
      + barRow(labels.legal, legal, '', false, true)
      + '</div>'
      + '<div class="imws-contaminant-card__note">'
      + 'The state and national averages were calculated using the averages of the contaminant measurements for each utility in ' + esc(timeline) + '.<br>ppb = parts per billion'
      + '</div></div></div>';
    return html;
  }

  /* ── Main class ───────────────────────────────────────────── */
  class ImwsForm {
    constructor(sectionEl) {
      this.section = sectionEl;
      this.form = sectionEl.querySelector('form');
      this.input = sectionEl.querySelector('.imws__zip-input') || sectionEl.querySelector('.imws__input');
      this.emailInput = sectionEl.querySelector('.imws__email-input');
      this.submitBtn = sectionEl.querySelector('.imws__submit');
      this.submitText = sectionEl.querySelector('.imws-hero__submit-text');
      this.submitSpinner = sectionEl.querySelector('.imws-hero__submit-spinner');
      this.errorEl = sectionEl.querySelector('.imws__error');
      this.landingEl = sectionEl.querySelector('[id^="imws-landing"]');
      this.resultsEl = sectionEl.querySelector('[id^="imws-results"]');
      this.backBtn = sectionEl.querySelector('[id^="imws-back"]');

      this.utilityEl = sectionEl.querySelector('[data-imws-role="utility"]');
      this.legalEl = sectionEl.querySelector('[data-imws-role="legal"]');
      this.contaminantsEl = sectionEl.querySelector('[data-imws-role="contaminants"]');
      this.testedEl = sectionEl.querySelector('[data-imws-role="tested"]');

      this.apiBase = sectionEl.dataset.apiBase || '';
      this.showEmailCapture = sectionEl.dataset.showEmailCapture === 'true';
      this.emailRequired = sectionEl.dataset.emailRequired === 'true';
      this.originalBtnText = this.submitText ? this.submitText.textContent : this.submitBtn.textContent;
      this.lastLoadedZip = null;

      this.bindEvents();
      this.checkUrlParam();
    }

    bindEvents() {
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 5);
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.handleSubmit(); });
      this.backBtn.addEventListener('click', () => this.resetForm());
    }

    checkUrlParam() {
      var params = new URLSearchParams(window.location.search);
      var zip = (params.get('zipcode') || '').trim();
      if (!zip || zip.length !== 5 || !/^\d{5}$/.test(zip)) return;
      this.input.value = zip;
      this.handleSubmit();
    }

    async handleSubmit() {
      var zip = this.input.value.trim();
      if (zip.length !== 5) { this.showError('Please enter a valid 5-digit zip code.'); return; }

      var email = this.emailInput ? this.emailInput.value.trim() : '';
      if (this.showEmailCapture && this.emailRequired && (!email || !isValidEmail(email))) {
        this.showError('Please enter a valid email address.');
        if (this.emailInput) {
          this.emailInput.setAttribute('aria-invalid', 'true');
          this.emailInput.focus();
        }
        return;
      }

      if (email && !isValidEmail(email)) {
        this.showError('Please enter a valid email address.');
        if (this.emailInput) {
          this.emailInput.setAttribute('aria-invalid', 'true');
          this.emailInput.focus();
        }
        return;
      }

      this.clearError();
      this.setLoading(true);

      try {
        var base = this.apiBase.replace(/\/+$/, '');
        var [waterRes, utilityRes, locRes] = await Promise.all([
          fetch(base + '/water-data?zip=' + zip),
          fetch(base + '/utility-data?zip=' + zip),
          fetch(base + '/zip-location?zip=' + zip),
        ]);

        if (!waterRes.ok && !utilityRes.ok) throw new Error('No data found for this zip code. Please try another.');

        var waterData = waterRes.ok ? await waterRes.json() : null;
        var utilityData = utilityRes.ok ? await utilityRes.json() : null;
        var locData = await locRes.json().catch(function () { return { city: '', state: '' }; });

        if (!waterData && !utilityData) throw new Error('No water quality data available for this zip code.');

        if (email) {
          var emailSent = await this.submitHeroEmail(email, zip, waterData, utilityData, locData);
          if (!emailSent && this.emailRequired) {
            throw new Error('Unable to send your report. Please try again.');
          }
        }

        this.renderResults(zip, waterData, utilityData, locData);
      } catch (err) {
        this.showError(err.message || 'Unable to check water quality right now. Please try again later.');
      } finally {
        this.setLoading(false);
      }
    }

    async submitHeroEmail(email, zip, waterData, utilityData, locData) {
      var system = utilityData && utilityData.SystemList && utilityData.SystemList[0];
      var systemName = (system && system.SystemName) || 'Your Water Utility';
      var source = (system && system.PrimSource_fulltext) || 'Unknown Source';
      var population = (system && system.Population != null) ? String(system.Population) : '';
      var cityName = (locData && locData.city) ? toTitleCase(locData.city) : '';
      var state = (locData && locData.state) || '';
      var locationStr = (cityName && state) ? cityName + ', ' + state : zip;
      var filtered = filterOverLimit((waterData && waterData.ContaminantList) || []);
      var processedContaminants = buildProcessedContaminants(filtered);
      var base = this.apiBase.replace(/\/+$/, '');

      try {
        var subscribeRes = await fetch(base + '/klaviyo', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, zip: zip, source: 'WaterIqAnalyze' })
        });

        if (!subscribeRes.ok) return false;

        var emailRes = await fetch(base + '/klaviyo/email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            zip: zip,
            contaminants: processedContaminants,
            source: source,
            utility: systemName,
            location: locationStr,
            serves: population
          })
        });

        if (emailRes.ok) {
          return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    }

    toggleLandingSections(visible) {
      var selectors = ['.imws-tap', '.imws-faq'];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el) el.hidden = !visible;
      }
      var imwsResultsHiddenSectionKeys = [
        'hero_d9FCLN',
        'section_LhfbBA',
        'section_HBKGpf',
        'hero_GFgc6K',
        'section_38it6G',
      ];
      for (var j = 0; j < imwsResultsHiddenSectionKeys.length; j++) {
        var key = imwsResultsHiddenSectionKeys[j];
        var sectionWrap = document.querySelector('[id$="__' + key + '"]');
        if (sectionWrap) sectionWrap.hidden = !visible;
      }
    }

    renderResults(zip, waterData, utilityData, locData) {
      this.landingEl.hidden = true;
      this.resultsEl.hidden = false;
      this.toggleLandingSections(false);
      this.lastLoadedZip = zip;

      var url = new URL(window.location);
      url.searchParams.set('zipcode', zip);
      window.history.pushState({}, '', url);

      var system = utilityData && utilityData.SystemList && utilityData.SystemList[0];
      var systemName = (system && system.SystemName) || 'Your Water Utility';
      var source = (system && system.PrimSource_fulltext) || 'Unknown Source';
      var population = (system && system.Population != null) ? Number(system.Population).toLocaleString() : 'N/A';
      var cityName = (locData && locData.city) ? toTitleCase(locData.city) : '';
      var state = (locData && locData.state) || '';
      var locationStr = (cityName && state) ? cityName + ', ' + state : zip;

      var allContaminants = (waterData && waterData.ContaminantList) || [];
      var filtered = filterOverLimit(allContaminants);
      var overCount = filtered.length;

      this.renderUtilitySection(systemName, locationStr, population, source);
      this.renderLegalSection(overCount, systemName, zip, source, population, locationStr, filtered);
      this.renderContaminantsList(filtered);
      this.renderTestedSection(systemName);

      var announcer = this.section.querySelector('[data-imws-results-announcer]');
      if (announcer) {
        announcer.textContent = 'Water analysis results loaded for ' + locationStr + '. '
          + overCount + ' contaminants reported above acceptable health limits.';
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* ── 1. Utility Section ──────────────────────────────────── */
    renderUtilitySection(systemName, locationStr, population, source) {
      var el = this.utilityEl;
      if (!el) return;
      var lblLoc = attr(el, 'label-location', 'Location');
      var lblServes = attr(el, 'label-serves', 'Serves');
      var lblSource = attr(el, 'label-source', 'Source');
      var lblData = attr(el, 'label-data', 'Data');
      var dataRange = attr(el, 'data-range', '2021\u20132023');
      var ewgText = attr(el, 'ewg-text', 'Powered by EWG Tap Water Database');
      var ewgNote = attr(el, 'ewg-note', '');
      var ewgLogo = attr(el, 'ewg-logo', '');

      function statCell(label, value) {
        return '<div><p class="imws-utility__grid-label">' + esc(label) + '</p>'
          + '<p class="imws-utility__grid-value">' + esc(value) + '</p></div>';
      }

      el.innerHTML = '<div><p class="imws-utility__label">UTILITY</p>'
        + '<p class="imws-utility__name">' + esc(systemName) + '</p></div>'
        + '<div class="imws-utility__grid">'
        + statCell(lblLoc, locationStr)
        + statCell(lblServes, population)
        + statCell(lblSource, source)
        + statCell(lblData, dataRange)
        + '</div>'
        + '<div class="imws-utility__ewg">'
        + '<div class="imws-utility__ewg-main">'
        + (ewgLogo ? '<img src="' + esc(ewgLogo) + '" class="imws-utility__ewg-logo" alt="EWG Logo" />' : '')
        + '<p class="imws-utility__ewg-text">' + esc(ewgText) + '</p>'
        + '</div>'
        + (ewgNote ? '<p class="imws-utility__ewg-note">' + esc(ewgNote) + '</p>' : '')
        + '</div>'
    }

    /* ── 2. Legal Section ────────────────────────────────────── */
    renderLegalSection(overCount, systemName, zip, utilitySource, utilityPopulation, locationStr, filtered) {
      var el = this.legalEl;
      if (!el) return;

      var title = attr(el, 'title', 'Legal does not necessarily equal safe.');
      var bullets = [
        attr(el, 'bullet-1', 'Federal limits don\u2019t always reflect the latest health research.'),
        attr(el, 'bullet-2', 'Legal limits for contaminants in tap water have not been updated in almost 20 years.'),
        attr(el, 'bullet-3', 'The best way to ensure clean tap water is to keep pollution out of source water in the first place.')
      ];
      var reportedLabel = attr(el, 'reported-label', 'Reported Over Acceptable Health Limit');
      var showEmailCapture = el.getAttribute('data-show-email-capture') === 'true';
      var emailHeading = attr(el, 'email-heading', 'Get Your Full Water Safety Report');
      var emailDesc = attr(el, 'email-desc', 'Enter your email to receive your full report and learn how to protect your household from harmful contaminants.');
      var emailBtnText = attr(el, 'email-btn', 'Send My Report');
      var emailSentText = attr(el, 'email-sent', 'Report Sent!');
      var privacy = attr(el, 'privacy', 'We respect your privacy and will never share your email.');

      var donut = buildDonutSVG(overCount);
      var bulletsHtml = bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
      var shareUrl = encodeURIComponent(window.location.href);
      var emailSectionHtml = '';

      if (showEmailCapture) {
        emailSectionHtml = '<div class="imws-legal__email-section">'
          + '<p class="imws-legal__email-heading">' + esc(emailHeading) + '</p>'
          + '<p class="imws-legal__email-desc">' + esc(emailDesc) + '</p>'
          + '<div class="imws-legal__email-form">'
          + '<label for="imws-report-email" class="visually-hidden">Email address</label>'
          + '<input type="email" id="imws-report-email" class="imws-legal__email-input" placeholder="Email address" autocomplete="email">'
          + '<button type="button" class="imws-legal__email-btn">'
          + '<span class="imws-legal__email-btn-text">' + esc(emailBtnText) + '</span>'
          + '<svg class="imws-legal__email-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">'
          + '<path d="M12 2v4m0 12v4m-7.07-3.93 2.83-2.83m8.48-8.48 2.83-2.83M2 12h4m12 0h4M4.93 4.93l2.83 2.83m8.48 8.48 2.83 2.83"/>'
          + '</svg>'
          + '</button>'
          + '</div>'
          + '<p class="imws-legal__email-privacy">' + esc(privacy) + '</p>'
          + '<p class="imws-legal__email-error" id="imws-email-error" role="alert" hidden></p>'
          + '</div>';
      }

      el.innerHTML = '<div class="imws-legal__inner' + (showEmailCapture ? '' : ' imws-legal__inner--no-email') + '">'
        + '<div class="imws-legal__left">'
        + '<div class="imws-legal__donut-wrap">' + donut
        + '<div class="imws-legal__donut-center">'
        + '<div class="imws-legal__donut-count">' + overCount + '</div>'
        + '<div class="imws-legal__donut-label">contaminants</div>'
        + '</div></div>'
        + '<p class="imws-legal__reported">' + esc(reportedLabel) + '</p>'
        + '<button type="button" class="imws-legal__share-prompt" data-imws-open-report>'
        + '<svg class="imws-legal__download-icon" width="12" height="16" viewBox="0 0 12 16" fill="none" aria-hidden="true"><path d="M6 0v11m0 0L1 6.5m5 4.5l5-4.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M0 14h12" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + ' Download your Contaminant Report to share on social media:'
        + '</button>'
        + '<div class="imws-legal__social">'
        + '<a href="https://www.facebook.com/sharer/sharer.php?u=' + shareUrl + '" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/facebook.png?v=1777308229" alt="Facebook" loading="lazy"></a>'
        + '<a href="https://twitter.com/intent/tweet?url=' + shareUrl + '&text=Check+out+my+water+report" target="_blank" rel="noopener noreferrer" aria-label="Share on X"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/x-twitter.png?v=1777308229" alt="X" loading="lazy"></a>'
        + '<a href="https://www.reddit.com/submit?url=' + shareUrl + '&title=Check+out+my+water+report" target="_blank" rel="noopener noreferrer" aria-label="Share on Reddit"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/reddit.png?v=1777308229" alt="Reddit" loading="lazy"></a>'
        + '<a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Share on Instagram"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/instagram.png?v=1777308229" alt="Instagram" loading="lazy"></a>'
        + '<a href="https://api.whatsapp.com/send?text=Check+out+my+water+report:+' + shareUrl + '" target="_blank" rel="noopener noreferrer" aria-label="Share on WhatsApp"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/whatsapp.png?v=1777308228" alt="WhatsApp" loading="lazy"></a>'
        + '<a href="mailto:?subject=Check%20out%20my%20water%20report&body=Here%20is%20the%20link%20to%20my%20water%20report:%20' + shareUrl + '" aria-label="Share via Email"><img src="https://cdn.shopify.com/s/files/1/0640/4115/6719/files/envelope.png?v=1777308229" alt="Email" loading="lazy"></a>'
        + '</div></div>'
        + '<div class="imws-legal__divider"></div>'
        + '<div class="imws-legal__right">'
        + '<p class="imws-legal__title">' + esc(title) + '</p>'
        + '<ul class="imws-legal__bullets">' + bulletsHtml + '</ul>'
        + emailSectionHtml
        + '</div></div></div>';

      var btn = el.querySelector('.imws-legal__email-btn');
      var btnTextEl = el.querySelector('.imws-legal__email-btn-text');
      var spinnerEl = el.querySelector('.imws-legal__email-spinner');
      var input = el.querySelector('.imws-legal__email-input');
      var apiBase = this.apiBase;
      var processedContaminants = buildProcessedContaminants(filtered || []);

      if (btn && input) {
        btn.addEventListener('click', async function () {
          var email = input.value.trim();
          var emailError = el.querySelector('#imws-email-error');
          if (!email || !zip) {
            if (emailError) {
              emailError.textContent = 'Please enter a valid email address.';
              emailError.hidden = false;
            }
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
          }
          if (emailError) emailError.hidden = true;
          input.setAttribute('aria-invalid', 'false');

          btn.disabled = true;
          if (btnTextEl) btnTextEl.textContent = 'Sending...';
          if (spinnerEl) spinnerEl.classList.add('is-visible');

          try {
            var base = apiBase.replace(/\/+$/, '');

            var subscribeRes = await fetch(base + '/klaviyo', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: email, zip: zip, source: 'WaterIqAnalyze' })
            });

            if (!subscribeRes.ok) {
              if (emailError) {
                emailError.textContent = 'Unable to send your report. Please try again.';
                emailError.hidden = false;
              }
              input.setAttribute('aria-invalid', 'true');
              if (btnTextEl) btnTextEl.textContent = emailBtnText;
              btn.disabled = false;
              if (spinnerEl) spinnerEl.classList.remove('is-visible');
              return;
            }

            var emailRes = await fetch(base + '/klaviyo/email', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: email,
                zip: zip,
                contaminants: processedContaminants,
                source: utilitySource || '',
                utility: systemName || '',
                location: locationStr || '',
                serves: utilityPopulation || ''
              })
            });

            if (emailRes.ok) {
              if (btnTextEl) btnTextEl.textContent = emailSentText;
              if (spinnerEl) spinnerEl.classList.remove('is-visible');
              input.disabled = true;
            } else {
              if (btnTextEl) btnTextEl.textContent = emailBtnText;
              btn.disabled = false;
              if (spinnerEl) spinnerEl.classList.remove('is-visible');
            }
          } catch (e) {
            if (btnTextEl) btnTextEl.textContent = emailBtnText;
            btn.disabled = false;
            if (spinnerEl) spinnerEl.classList.remove('is-visible');
          }
        });
      }

      var reportBtn = el.querySelector('[data-imws-open-report]');
      if (reportBtn) {
        var self = this;
        reportBtn.addEventListener('click', function () {
          self.openReportModal(overCount, systemName, locationStr, utilityPopulation, utilitySource);
        });
      }
    }

    /* ── Report Modal ──────────────────────────────────────── */
    openReportModal(count, systemName, locationStr, population, source) {
      var existing = document.getElementById('imws-report-modal');
      if (existing) existing.remove();

      var bgUrl = "https://cdn.builder.io/api/v1/image/assets%2Ff2b06d2e554043f0b2703af08544b2a3%2F421179972ad94b6e9203d5b93d22dbf0";

      var reportHtml = '<div id="imws-report-card" class="imws-report-card" style="'
        + 'width:1080px;height:1080px;background:linear-gradient(0deg,rgba(8,41,50,0.8),rgba(8,41,50,0.8)),url(\'' + bgUrl + '\') center/cover no-repeat;'
        + 'display:flex;flex-direction:column;align-items:center;justify-content:center;color:#fff;font-family:Avenir Next,Avenir,Arial,sans-serif;">'
        + '<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 20px;gap:24px;">'
        + '<canvas id="imws-report-canvas" width="974" height="974" style="width:487px;height:487px;"></canvas>'
        + '<p style="text-align:center;font-size:36px;font-weight:600;line-height:1.16;">Reported Over Acceptable Health Limit</p>'
        + '</div>'
        + '<div style="width:100%;background:rgba(23,26,31,0.5);">'
        + '<div style="display:flex;flex-direction:column;align-items:center;padding:40px 20px;gap:60px;">'
        + '<div style="text-align:center;">'
        + '<p style="font-size:20px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;">UTILITY</p>'
        + '<p style="font-size:40px;font-weight:600;line-height:1.2;margin-top:16px;">' + esc(systemName) + '</p>'
        + '</div>'
        + '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:20px;width:100%;text-align:center;">'
        + '<div><p style="font-size:20px;font-weight:500;text-transform:uppercase;">Location</p><p style="font-size:26px;font-weight:600;margin-top:8px;">' + esc(locationStr) + '</p></div>'
        + '<div><p style="font-size:20px;font-weight:500;text-transform:uppercase;">Serves</p><p style="font-size:26px;font-weight:600;margin-top:8px;">' + esc(population) + '</p></div>'
        + '<div><p style="font-size:20px;font-weight:500;text-transform:uppercase;">Source</p><p style="font-size:26px;font-weight:600;margin-top:8px;">' + esc(source) + '</p></div>'
        + '<div><p style="font-size:20px;font-weight:500;text-transform:uppercase;">Data</p><p style="font-size:26px;font-weight:600;margin-top:8px;">2021\u20132023</p></div>'
        + '</div></div></div></div>';

      var screenW = window.innerWidth;
      var avail = Math.min(screenW - 64, 800);
      var scale = Math.min(1, avail / 1080);

      var modal = document.createElement('div');
      var previousFocus = document.activeElement;

      modal.id = 'imws-report-modal';
      modal.className = 'imws-report-overlay';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Preview Shareable Report');
      modal.innerHTML = '<div class="imws-report-dialog">'
        + '<div class="imws-report-dialog__header">'
        + '<h2 class="imws-report-dialog__title">Preview Shareable Report</h2>'
        + '<button type="button" class="imws-report-dialog__close" aria-label="Close">&times;</button>'
        + '</div>'
        + '<div class="imws-report-dialog__body">'
        + '<div class="imws-report-dialog__preview" style="transform:scale(' + scale + ');width:' + 1080 * scale + 'px;height:' + 1080 * scale + 'px;">'
        + '<div style="width:1080px;height:1080px;transform-origin:top left;transform:scale(' + scale + ');">' + reportHtml + '</div>'
        + '</div>'
        + '</div>'
        + '<div style="position:fixed;top:-10000px;left:-10000px;pointer-events:none;">' + reportHtml.replace('imws-report-card', 'imws-report-card-hd').replace('imws-report-canvas', 'imws-report-canvas-hd') + '</div>'
        + '<div class="imws-report-dialog__footer">'
        + '<button type="button" class="imws-report-dialog__cancel">Cancel</button>'
        + '<button type="button" class="imws-report-dialog__download">'
        + '<svg width="16" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/></svg>'
        + '<span>Download Image</span>'
        + '</button>'
        + '</div></div>';

      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';

      this.drawReportDonut(document.getElementById('imws-report-canvas'), count);
      this.drawReportDonut(document.getElementById('imws-report-canvas-hd'), count);

      var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

      var closeModal = function () {
        modal.removeEventListener('keydown', onModalKeydown);
        modal.remove();
        document.body.style.overflow = '';
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      };

      var onModalKeydown = function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
          return;
        }
        if (e.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(modal.querySelectorAll(focusableSelector));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      modal.addEventListener('keydown', onModalKeydown);

      var closeButton = modal.querySelector('.imws-report-dialog__close');
      closeButton.addEventListener('click', closeModal);
      modal.querySelector('.imws-report-dialog__cancel').addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      closeButton.focus();

      var dlBtn = modal.querySelector('.imws-report-dialog__download');
      dlBtn.addEventListener('click', function () {
        var target = document.getElementById('imws-report-card-hd');
        if (!target) return;
        dlBtn.disabled = true;
        dlBtn.querySelector('span').textContent = 'Generating Image...';

        var renderCapture = function () {
          if (typeof html2canvas === 'undefined') {
            dlBtn.querySelector('span').textContent = 'Download Image';
            dlBtn.disabled = false;
            return;
          }
          html2canvas(target, { scale: 2, useCORS: true, logging: false, backgroundColor: '#2C3F4B' })
          .then(function (canvas) {
            var link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = 'Contaminant_Report.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dlBtn.querySelector('span').textContent = 'Download Image';
            dlBtn.disabled = false;
          })
          .catch(function () {
            dlBtn.querySelector('span').textContent = 'Download Image';
            dlBtn.disabled = false;
          });
        };

        if (typeof html2canvas !== 'undefined') {
          renderCapture();
          return;
        }

        var html2canvasSrc = this.section.dataset.html2canvasSrc;
        if (!html2canvasSrc) {
          dlBtn.querySelector('span').textContent = 'Download Image';
          dlBtn.disabled = false;
          return;
        }

        var script = document.createElement('script');
        script.src = html2canvasSrc;
        script.onload = renderCapture;
        script.onerror = function () {
          dlBtn.querySelector('span').textContent = 'Download Image';
          dlBtn.disabled = false;
        };
        document.head.appendChild(script);
      });
    }

    drawReportDonut(canvas, count) {
      if (!canvas) return;
      var size = 487;
      var sw = 30;
      var dpr = 2;
      canvas.width = size * dpr;
      canvas.height = size * dpr;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.scale(dpr, dpr);

      var cx = size / 2;
      var r = (size - sw) / 2;
      var clamped = Math.min(Math.max(count, 0), 100);
      var extra = clamped / 100;
      var start = -Math.PI / 2;

      ctx.lineCap = 'round';
      ctx.lineWidth = sw;

      var grey = ctx.createLinearGradient(0, 0, size, size);
      grey.addColorStop(0, '#6F7F84');
      grey.addColorStop(1, '#9AA7AB');
      ctx.beginPath();
      ctx.arc(cx, cx, r, 0, Math.PI * 2);
      ctx.strokeStyle = grey;
      ctx.stroke();

      var light = ctx.createLinearGradient(0, 0, size, size);
      light.addColorStop(0, 'rgba(240,62,63,0.6)');
      light.addColorStop(0.5, 'rgba(240,62,63,0.4)');
      light.addColorStop(1, 'rgba(253,22,23,0.6)');
      ctx.beginPath();
      ctx.arc(cx, cx, r, start, start + Math.PI * 2);
      ctx.strokeStyle = light;
      ctx.stroke();

      if (extra > 0) {
        var dark = ctx.createLinearGradient(0, 0, size, size);
        dark.addColorStop(0, 'rgba(253,22,23,0.9)');
        dark.addColorStop(1, '#fd1717');
        ctx.beginPath();
        ctx.arc(cx, cx, r, start, start + extra * Math.PI * 2);
        ctx.strokeStyle = dark;
        ctx.stroke();
      }

      ctx.fillStyle = '#E60012';
      ctx.textAlign = 'center';
      ctx.font = '600 182px "Avenir Next", Avenir, Arial, sans-serif';
      ctx.fillText(String(count), cx, cx + 50);
      ctx.font = '600 45px "Avenir Next", Avenir, Arial, sans-serif';
      ctx.fillText('contaminants', cx, cx + 110);
    }

    /* ── 3. Contaminants List ────────────────────────────────── */
    renderContaminantsList(filtered) {
      var el = this.contaminantsEl;
      if (!el) return;

      var heading = attr(el, 'heading', 'Contaminants Detected in Your Water Supply');
      var emptyText = attr(el, 'empty-text', 'No contaminants above health guidelines were found for this zip code.');
      var labels = {
        guideline: attr(el, 'guideline-label', 'EWG Health Guideline'),
        national: attr(el, 'national-label', 'National Average'),
        state: attr(el, 'state-label', 'State Average'),
        home: attr(el, 'home-label', '\uD83C\uDFE0 Your Home\'s Water'),
        legal: attr(el, 'legal-label', 'Legal Limit')
      };

      if (filtered.length === 0) {
        el.innerHTML = '<div style="text-align:center;padding:3rem 1rem;"><p style="opacity:0.7;font-size:1.1rem;">' + esc(emptyText) + '</p></div>';
        return;
      }

      var cardsHtml = filtered.map(function (c, i) { return buildCard(c, i, labels); }).join('');
      el.innerHTML = '<p class="imws-contaminants__heading">' + esc(heading) + '</p>'
        + '<div class="imws-contaminants__scroll">' + cardsHtml + '</div>';

      el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-toggle]');
        if (!btn) return;
        var id = btn.getAttribute('data-toggle');
        var expanded = el.querySelector('[data-expanded="' + id + '"]');
        if (!expanded) return;
        var isOpen = expanded.style.display !== 'none' && !expanded.hidden;
        var nextOpen = !isOpen;
        expanded.style.display = nextOpen ? 'block' : 'none';
        expanded.hidden = !nextOpen;
        btn.textContent = nextOpen ? '\u00D7' : '+';
        btn.setAttribute('aria-expanded', String(nextOpen));
        var contaminantName = btn.closest('.imws-contaminant-card')
          && btn.closest('.imws-contaminant-card').querySelector('.imws-contaminant-card__name');
        var nameText = contaminantName ? contaminantName.textContent.trim() : 'contaminant';
        btn.setAttribute(
          'aria-label',
          (nextOpen ? 'Collapse details for ' : 'Expand details for ') + nameText
        );
      });
    }

    /* ── 4. Tested Section ───────────────────────────────────── */
    renderTestedSection(systemName) {
      var el = this.testedEl;
      if (!el) return;

      var sectionTitle = attr(el, 'section-title', 'Other Contaminants Tested');
      var detectedIntro = attr(el, 'detected-intro', 'Contaminants detected between 2012 and 2014 and were not part of EPA\u2019s UCMR-3 testing program or radiologicals:');
      var notDetectedIntro = attr(el, 'not-detected-intro', 'Chemicals tested for but not detected from 2012 to 2017:');
      var complianceTemplate = attr(el, 'compliance-template', 'From April 2016 to March 2019, {name} complied with health-based drinking water standards.');

      var detectedHtml = DETECTED_CONTAMINANTS.map(function (c) { return '<div>' + esc(c) + '</div>'; }).join('');
      var notDetectedHtml = NOT_DETECTED.map(function (col) {
        return '<div>' + col.map(function (c) { return '<div>' + esc(c) + '</div>'; }).join('') + '</div>';
      }).join('');

      var complianceText = complianceTemplate.replace(/\{name\}/g, systemName);

      el.innerHTML = '<div class="imws-tested__disclaimer">'
        + '<p>Includes chemicals detected in 2015\u20132017 for which annual utility averages exceeded the federal Maximum Contaminant Level (MCL); chemicals detected in 2015\u20132017 for which annual utility averages exceeded an EWG-selected health guideline established by a federal or state public health authority; chemicals detected under the EPA\u2019s Unregulated Contaminant Monitoring Rule (UCMR 3) program in 2013 to 2015 (and subsequent testing when available), for which annual utility averages exceeded a health guideline established by a federal or state public health authority; radiological contaminants detected between 2012 and 2017.</p>'
        + '<p>\u2020 HAA5 is a contaminant group that includes monochloroacetic acid, dichloroacetic acid, trichloroacetic acid, monobromoacetic acid and dibromoacetic acid. TTHM is a contaminant group that includes bromodichloromethane, bromoform, chloroform and dibromochloromethane.</p>'
        + '</div>'
        + '<p class="imws-tested__section-title">' + esc(sectionTitle) + '</p>'
        + '<p class="imws-tested__sub">' + esc(detectedIntro) + '</p>'
        + '<div class="imws-tested__chem-grid">' + detectedHtml + '</div>'
        + '<div class="imws-tested__not-detected">'
        + '<p class="imws-tested__sub" style="font-weight:500;">' + esc(notDetectedIntro) + '</p>'
        + '<div class="imws-tested__not-detected-grid">' + notDetectedHtml + '</div>'
        + '</div>'
        + '<div class="imws-tested__compliance">'
        + '<p class="imws-tested__compliance-title">' + esc(systemName) + ' compliance with legally mandated federal standards:</p>'
        + '<p class="imws-tested__compliance-text">' + esc(complianceText) + '</p>'
        + '</div>';
    }

    /* ── Shared helpers ──────────────────────────────────────── */
    resetForm() {
      this.resultsEl.hidden = true;
      this.landingEl.hidden = false;
      this.toggleLandingSections(true);
      if (this.utilityEl) this.utilityEl.innerHTML = '';
      if (this.legalEl) this.legalEl.innerHTML = '';
      if (this.contaminantsEl) this.contaminantsEl.innerHTML = '';
      if (this.testedEl) this.testedEl.innerHTML = '';
      this.input.value = '';
      if (this.emailInput) this.emailInput.value = '';
      this.lastLoadedZip = null;
      this.input.focus();

      var url = new URL(window.location);
      url.searchParams.delete('zipcode');
      window.history.replaceState({}, '', url);
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      if (this.input) this.input.setAttribute('aria-invalid', 'true');
    }
    clearError() {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
      if (this.input) this.input.setAttribute('aria-invalid', 'false');
      if (this.emailInput) this.emailInput.setAttribute('aria-invalid', 'false');
    }

    setLoading(loading) {
      this.submitBtn.disabled = loading;
      this.input.disabled = loading;
      if (this.emailInput) this.emailInput.disabled = loading;

      if (this.submitText && this.submitSpinner) {
        this.submitText.textContent = loading ? 'Analyzing\u2026' : this.originalBtnText;
        this.submitSpinner.hidden = !loading;
      } else {
        this.submitBtn.textContent = loading ? 'Analyzing\u2026' : this.originalBtnText;
      }
    }
  }

  window.ImwsForm = ImwsForm;
})();

document.querySelectorAll('.imws').forEach(function (el) {
  if (!el.dataset.imwsBound) {
    el.dataset.imwsBound = 'true';
    new ImwsForm(el);
  }
});
